<app-auth-view>
  <ng-container slot="title">Support Toegang</ng-container>
  <ng-container slot="message">
    Verifiëren van CRM support-sessie...
  </ng-container>

  <ng-container slot="content">
    <div class="mt-10 flex flex-col items-center justify-center min-h-[160px]">
      @if (status() === 'loading') {
        <mat-spinner diameter="40" />
        <p class="mt-4 text-sm text-gray-600 font-medium">
          Inloggen bij klantomgeving...
        </p>
      } @else {
        <div class="w-full bg-red-50 border border-red-200 rounded-lg p-4 text-sm text-red-900 mb-6">
          <p class="font-semibold mb-1">Inloggen mislukt</p>
          <p>{{ errorMessage() }}</p>
        </div>
        <button mat-flat-button color="primary" class="w-full" (click)="goToLogin()">
          Naar reguliere inlogpagina
        </button>
      }
    </div>
  </ng-container>
</app-auth-view>
